export default __webpack_public_path__ + "static/media/double-check.51d0bbc5.svg";